import React, { useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

const customToolbarStyle = {
  backgroundColor: "#e3f2fd",
  color: "#333",
  padding: "16px",
  borderRadius: "8px",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.12)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

function Header({
  selectedTime,
  setSelectedTime,
  selectedMachine,
  setSelectedMachine,
}) {
  return (
    <Box sx={{ flexGrow: 1, mb: 2 }}>
      <Toolbar sx={customToolbarStyle}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="large"
            edge="start"
            color="primary"
            aria-label="live tracking"
            sx={{ mr: 2 }}
          >
            <PlayCircleOutlineIcon />
          </IconButton>
          <Typography variant="h6" component="div">
            Live Tracking
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FormControl
            variant="outlined"
            size="small"
            sx={{ minWidth: 120, mr: 2 }}
          >
            <InputLabel id="time-select-label" sx={{ fontSize: "18px" }}>
              Select Time
            </InputLabel>
            <Select
              labelId="time-select-label"
              id="time-select"
              value={selectedTime}
              onChange={(event) => setSelectedTime(event.target.value)}
              label="Select Time"
            >
              <MenuItem value="5m">Past 5m</MenuItem>
              <MenuItem value="15m">Past 15m</MenuItem>
              <MenuItem value="30m">Past 30m</MenuItem>
              <MenuItem value="40m">Past 40m</MenuItem>
              <MenuItem value="45m">Past 45m</MenuItem>
              <MenuItem value="1h">Past 1h</MenuItem>
              <MenuItem value="2h">Past 2h</MenuItem>
              <MenuItem value="3h">Past 3h</MenuItem>
              <MenuItem value="5h">Past 5h</MenuItem>
              <MenuItem value="6h">Past 6h</MenuItem>
              <MenuItem value="12h">Past 12h</MenuItem>
              <MenuItem value="24h">Past 24h</MenuItem>
              <MenuItem value="2d">Past 2d</MenuItem>
              <MenuItem value="7d">Past 7d</MenuItem>
              <MenuItem value="30d">Past 30d</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
            <InputLabel id="machine-select-label" sx={{ fontSize: "18px" }}>
              Choose Machine
            </InputLabel>
            <Select
              labelId="machine-select-label"
              id="machine-select"
              value={selectedMachine}
              onChange={(event) => setSelectedMachine(event.target.value)}
              label="Choose Machine"
            >
              <MenuItem value="AC:15:18:F7:6C:68">T&D Tracker</MenuItem>
              <MenuItem value="AC:15:18:F8:BA:6C">TES Tracker</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Toolbar>
    </Box>
  );
}
export default Header;
